module.exports = __webpack_public_path__ + "media/images/Tick-11998cf525e338557eb770d046b4b08b.svg";